<template>
    <Plaid
            :env="plaidenv"
            :onEvent='onEvent'
            :onExit='onExit'
            :onLoad='onLoad'
            :onSuccess='onSuccess'
            :products="['auth','transactions']"
            :public_key="publickey"
            clientName="APPLICATION NAME"
            webhook="https://requestb.in">
        <button class="btn btn-success waves-effect waves-light text-white"><i class="fas fa-plus"></i>&nbsp;Link Bank Account</button>
    </Plaid>
</template>

<script>
    import Plaid from "./Plaid";

    export default {
        name: "LinkAccount",
        components: {Plaid},
        data() {
            return {
                publickey: '',
                plaidenv: ''
            }
        },
        beforeMount() {
            this.init();
        },
        methods: {
            async init() {
                await this.getKey();
            },
            async getKey() {
                try {
                    let reply      = await this.$http.get("/banking/key");
                    this.plaidenv  = reply.data.env;
                    this.publickey = reply.data.publickey;
                } catch(e) {
                    console.log(e);
                }
            },
            async onSuccess(public_token) {
                this.$router.push({name: 'listaccounts', params: {public_token}});
            },
            onLoad() {

            },
            onExit() {

            },
            onEvent() {

            }
        }
    }
</script>

<style scoped>
</style>
